export default __webpack_public_path__ + "static/media/icon-send-help.a1a35469.svg";